import { useEffect, useState } from "react";
import { getBooks, deleteBook } from "../services/api";
import { Link } from "react-router-dom";

function BookList() {
  const [books, setBooks] = useState([]);

  useEffect(() => {
    getBooks()
      .then(data => {
        console.log("API data:", data);
        setBooks(data);
      })
      .catch(err => {
        console.error("API error:", err);
      });
  }, []);

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this book?")) {
      deleteBook(id).then(() => {
        setBooks(books.filter(book => book.id !== id));
      });
    }
  };

  return (
    <div className="container">
       <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h3>Book List</h3>

        <Link to="/add">
          <button>Add Book</button>
        </Link>
      </div>

      {books.length === 0 ? (
        <p>No books found</p>
      ) : (
        <table width="100%" border="1" cellPadding="8">
          <thead>
            <tr>
              <th>#</th>
              <th>Book Name</th>
              <th>Author</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {books.map((book, index) => (
              <tr key={book.id}>
                <td>{index + 1}</td>

                <td>
                  <Link to={`/details/${book.id}`}>
                    {book.title}
                  </Link>
                </td>

                <td>{book.author}</td>

                <td>
                  <Link to={`/edit/${book.id}`}>Edit</Link>{" "}
                  <button onClick={() => handleDelete(book.id)}>
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default BookList;
